import { Route } from 'react-router-dom';
import { DashboardPage } from './pages/DashboardPage.js';

/**
 * Dashboard — landing page after auth. Charts of license-level KPIs
 * read through `app-api → audit-engine` (no direct engine calls from
 * the SPA). MVP today is the per-license summary; subsequent commits
 * stack more endpoints + the chart suite.
 */
export function dashboardRoutes(): JSX.Element {
  return <Route path="/dashboard" element={<DashboardPage />} />;
}
